import styled from 'styled-components'

export const CreatorLogoContainer = styled.div`
  width: 3.1rem;
`
